import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

import { resetPassword, checkedVerified } from '../../app/actions/authActions';
import { showAlert, hideAlert } from '../../app/actions/uiActions';
import Title from '../../components/Title';
import Input from '../../components/Input';
import Button from '../../components/Button';
import AlertMessage from '../../components/AlertMessage';
import { withAuthLayout } from '../../components/hocs/withAuthLayout';

const ResetPassword = () => {
	const history = useHistory();
	
	const dispatch = useDispatch();
	const uid = useSelector((state) => state.firebase.auth.uid);
	const ui = useSelector((state) => state.ui);
	const isVerified = useSelector((state) => state.auth.isVerified);
	const approved = useSelector((state) => state.auth.approved);

	const [email, setEmail] = useState('');

	const handleSubmit = (event) => {
		event.preventDefault();

		if(email.length){
			dispatch(resetPassword(email))
		} else {
			dispatch(showAlert({type: "error", text: "The email field must be filled"}));
		};
	};

	const handleChangeInput = (target) => {
		setEmail( target.value);
	};

	const handleRedirect = (event) => {
		event.preventDefault();
		history.push(`/${event.target.name}`);
	};

	useEffect(()=>{
		uid && dispatch(checkedVerified(uid));
		dispatch(hideAlert());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[]); 

	useEffect(() => {
		if(uid && isVerified && approved) {
			history.push('/');
		};

		if(ui.showAlert.type === 'emailVerify' || ui.showAlert.type === 'approve') {
			dispatch(hideAlert());
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[uid,isVerified,approved,ui.showAlert]);

	return (
		<div className="auth__content">
			<Title text={'Resset Password'} isBig isBold/>
			<AlertMessage showAlert={ui.showAlert}/>
			<p className="text-center">
				Enter your email associated with the account and we will send you a link to reset.
			</p>
			<form 
				className="auth__form"
				onSubmit={handleSubmit}
			>
				<Input 
					value={email}
					id='email'
					type='email' 
					label='email' 
					onChange={handleChangeInput}
					required 
				/>
				<div className="auth__btn">
					<Button text='Send Link'/>
				</div>
			</form>
			<div className="auth__controls">
				<a 
					href="/"
					className="auth__controls-item"
					name="login" 
					onClick={handleRedirect}
				>
					Login
				</a>
				<a 
					href="/"
					className="auth__controls-item"
					name="sign-up" 
					onClick={handleRedirect}
				>
					Create an account?
				</a>
			</div>
		</div>
	);
};

export default withAuthLayout(ResetPassword);
